import React, { FunctionComponent, ReactNode } from 'react';
import cn from 'classnames';

import './PageHeader.scss';

interface IPageHeaderProps {
    className?: string;
    right?: ReactNode;
    title?: ReactNode;
}

export const PageHeader: FunctionComponent<IPageHeaderProps> = (props) => (
    <div className={cn('pageHeader', props.className)}>
        <div className="col pageHeader_titleWrapper">
            <h1 className="pageHeader_title">{props.title}</h1>
        </div>
        {props.right && props.right}
        {!props.right && (
            <div style={{paddingTop: "48px"}}></div>
        )}
    </div>
);